module.exports = __webpack_public_path__ + "static/Vassar-e7e035b8363de7d8108e26b9a703938f.png";